<template>
  <div class="bless">
    <img src="../assets/words_to_teacher.png" alt="写下你想对英语老师说的话" class="wordsToTeacher">
    <div class="main">
      <label class="yourName" for="username">
        <img class="yourName" src="../assets/your_name.png">
      </label>
      <input type="text" v-model="username" id="username"  v-on:focus="getHeight">
      <img class="borderImg" src="../assets/line_top.png" >
      <label class="blessing" for="blessing" class="blessing">
        <img class="blessing" src="../assets/your_words.png">
      </label>
      <textarea v-model="blessing" rows="5" maxlength="50" id="blessing" placeholder="(限定50个字，不允许填写特殊字符)" v-on:focus="getHeight"></textarea>
    </div>
    <a class="btn" @click="toTeacher">
      <img src="../assets/btn_create.png" alt="生成贺卡">
    </a>
    <v-Dialog :display.sync="display" :msg="msg"></v-Dialog>
  </div>
</template>

<script>
  import vDialog from '../components/Dialog.vue'

  module.exports = {
    data: function () {
      return {
        display: false,
        username: "",
        blessing: "",
        msg: "",
        get: false
      }
    },
    components: {
      vDialog
    },
    /*ready: function() {
      let self = this
      if (self.$route.query.teacherName == undefined ||
        self.$route.query.mobile == undefined) {
        self.$router.go({path:'/'});
      }
    },*/
    methods: {
      toTeacher: function () {
        let self = this

        if (!self.username || !self.blessing) {
          self.display = true;
          self.msg = "有信息未填写,请完善后再提交";
          return
        }

        //屏蔽emoji表情和特殊字符
        var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
        var pattern = new RegExp("[`~!@#$^&*()=|{}''\\[\\]<>/?~@#￥&*（）&;—|{}【】‘”“']")

        if (regStr.test(self.username) || regStr.test(self.blessing) || pattern.test(self.username) || pattern.test(self.blessing)) {
          self.display = true
          self.msg = "不能输入特殊字符，请重新输入"
          return
        }

        /*let params = '&name=' + self.$route.query.teacherName +
                '&phone=' + self.$route.query.mobile +
                '&area=' + self.$route.query.province +
                '&address=' + self.$route.query.province + self.$route.query.city + self.$route.query.county + self.$route.query.address +
                '&age=' + self.username + '&fixPhone=' + self.blessing ;

        let url = 'http://impservice.youdao.com/shutup/submit.s?from=teachers-Cards-20170328' + params;

        $.ajax({
          url: url,
          success: function (data) {
            console.log(data);
          },
          error: function (data) {
            console.log(data);
          }
        });*/

        /*self.$router.go({ name:'card',query: {
          userName: self.username,
          mobile: self.$route.query.mobile
        }
        });*/
        self.$router.go({
          name: 'teacher', query: {
            userName: self.username,
            blessing: self.blessing
          }
        });

      },
      getHeight: function () {
        if (this.get || ydk.isIos) return

        //安卓手机调起键盘图片会被压缩
        const height = $('.main').height()
        $(window).resize(function () {
          if (document.activeElement.tagName == 'INPUT' ||
            document.activeElement.tagName == 'TEXTAREA') {
            window.setTimeout(function () {
              document.activeElement.scrollIntoViewIfNeeded();
            }, 0);
          }
        })
        this.get = true
      }
    }
  }
</script>

<style scoped>
  .bless {
    width: 100%;
    height: 100%;
    background: url("../assets/p3.jpg") 0 0/100% 100% no-repeat;
  }

  .wordsToTeacher{
    display: block;
    width: 3.89rem;
    height: 0.73rem;
    margin: 26% auto 0;
  }

  .main {
    width: 90%;
    height: 7rem;
    background: url("../assets/word_bg.png") 0 0/100% 100% no-repeat;
    margin: 2% auto 0;
    padding: 21% 18% 0;
    box-sizing: border-box;
  }

  .yourName{
    width: 1.05rem;
    height: 0.26rem;
  }

  .borderImg{
    display: block;
    width: 100%;
    height: 1%;
    margin-bottom: 12%;
  }

  .blessing{
    width: 1.62rem;
    height: 0.26rem;
  }

  label {
    display: block;
  }

  input{
    display: block;
    width: 100%;
    background-color: #fdf8f5;
    line-height: 0.35rem;
    font-size: 0.28rem;
    margin-top: 0.1rem;
    padding: 0 1%;
    border: none;
    box-sizing: border-box;
    outline: none;
  }

  textarea {
    display: block;
    width: 100%;
    height: 39%;
    line-height: 0.41rem;
    padding: 1%;
    font-size: 0.28rem;
    border: none;
    box-sizing: border-box;
    outline: none;
    background: url("../assets/line_down.png") 0 0/4rem 2.05rem no-repeat;
  }

  .btn {
    width: 41%;
    height: 6%;
    margin: 6% auto 0;
    -webkit-tap-highlight-color: transparent;
  }

  @media screen  and (max-height: 600px) {
    .wordsToTeacher{
      margin: 22% auto 0;
    }
    .btn{
      margin: 5% auto 0;
    }
    .main{
      height: 7rem;
    }
  }

  @media screen and (max-width: 360px) and (max-height: 540px) {
    .wordsToTeacher{
      margin: 20% auto 0;
    }
    .main{
      height: 6.5rem;
    }
    .btn{
      margin: 2% auto 0;
    }
  }

  @media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){
    .wordsToTeacher{
      margin: 22% auto 0;
    }
    .btn{
      margin: 4% auto 0;
    }
    .main{
      height: 7rem;
    }
  }
  @media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){
    .wordsToTeacher{
      margin: 22% auto 0;
    }
    .btn{
      margin: 4% auto 0;
    }
    .main{
      height: 7rem;
    }
  }
  @media screen and (min-height: 800px)  {
    .wordsToTeacher{
      margin: 32% auto 0;
    }

    .main{
      padding: 21% 18% 0;
      height: 7rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Blessing.vue?67327a05